import React, { useCallback, useState } from 'react';
import UnityGameDockApp from './UnityGameDockApp';

const DEFAULT_COOLDOWN_MS = 1800;

export interface BreakoutClapDockProps {
  disabled?: boolean;
  onClap: () => Promise<void>;
  clapCooldownMs?: number;
  dataTourId?: string;
}

const BreakoutClapDock: React.FC<BreakoutClapDockProps> = ({
  disabled = false,
  onClap,
  clapCooldownMs = DEFAULT_COOLDOWN_MS,
  dataTourId,
}) => {
  const [pending, setPending] = useState(false);
  const [errorFlash, setErrorFlash] = useState(false);
  const [cooldownUntil, setCooldownUntil] = useState(0);

  const inCooldown = Date.now() < cooldownUntil;
  const canClap = Boolean(onClap) && !disabled && !pending && !inCooldown;

  const handleClapClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!canClap) return;
      setPending(true);
      try {
        await onClap();
        setCooldownUntil(Date.now() + clapCooldownMs);
      } catch {
        setErrorFlash(true);
        window.setTimeout(() => setErrorFlash(false), 2000);
      } finally {
        setPending(false);
      }
    },
    [canClap, clapCooldownMs, onClap]
  );

  const title = !onClap || disabled ? 'Clap (connect to chat in this room)' : 'Send applause to everyone in this room';

  return (
    <UnityGameDockApp
      dataTourId={dataTourId}
      ariaLabel={title}
      label="Clap"
      icon={<span className="text-2xl leading-none">👏</span>}
      disabled={!canClap}
      wrapperClassName={errorFlash ? 'ring-2 ring-red-400 rounded-xl' : ''}
      tileClassName="bg-gradient-to-br from-emerald-600 to-green-800"
      onClick={handleClapClick}
    />
  );
};

export default BreakoutClapDock;
